import { UserType } from "@bvhi/backend-api";
import { Chip } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  type: string;
  size?: "small" | "medium";
}

export function UserTypeChip({ type, size = "small" }: Props) {
  const { t } = useTranslation(["enums"]);

  const label = useMemo(() => {
    if (type === UserType.ADMIN) return t("enums:enums.user.type.admin");
    if (type === UserType.AUDIOLOGIST) return t("enums:enums.user.type.audiologist");
    if (type === UserType.ERP_SUPPLIER) return t("enums:enums.user.type.erp.supplier");
    if (type === UserType.SUPPLIER) return t("enums:enums.user.type.supplier");

    return "";
  }, [type, t]);

  return <Chip label={label} size={size} />;
}
